angular.module('unica_transfer.transfer_controllers')

.controller('TransferListController', function(
	$rootScope, $scope, $state,
	$confirm,
	TransferListService, TransferDeleteService
) {
	$scope.transferList = [];
	$scope.limit  = 10;
	$scope.offset = 0;
	$scope.canLoad = true;

	$scope.loadTransfers = function() {
		$scope.showLoader();
		$scope.canLoad = false;
		TransferListService
			.list($scope.limit, $scope.offset)
			.then(function(data) {
				$scope.hideLoader();

				if (!data.error) {
					$scope.transferList = $scope.transferList.concat( data );
					if ( data.length == 0 ) {
						$scope.canLoad = false;
					} else {
						$scope.canLoad = true;
						$scope.offset = $scope.offset + data.length;
					}
				} else {
					$rootScope.manageError(data);
				}
			});
	};

	$scope.loadTransfers();

	$scope.deleteTransfer = function(transferId) {

		$confirm({
			title: 'Sei sicuro di voler eliminare il transfer?',
			text: 'Confermi la cancellazione della il transfer?'
		}).then(function() {

			$scope.showLoader();
			TransferDeleteService
				.delete( transferId )
				.then(function(data) {
					$scope.hideLoader();

					if (!data.error) {
						angular.forEach($scope.transferList, function(transfer, key) {
							if ( transfer.id == transferId ) {
								$scope.transferList.splice(key, 1);
							}
						});
						$scope.showSuccessMsg('Transfer eliminato con successo!', '');
					} else {
						$rootScope.manageError(data);
					}

				});

		}, function() {
			// Cancel
		});

	};

})

;